import { rejected, resolved } from 'store/createAction';
import {
  LOAD_INTEGRATIONS,
  SAVE_INTEGRATION,
  START_SYNC,
  TOGGLE_BANNER,
} from '../types';

const initialState = {
  data: [],
  loading: false,
  showBanner: true,
  syncIntegration: null,
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOAD_INTEGRATIONS:
      return {
        ...state,
        loading: true,
      };
    case resolved(LOAD_INTEGRATIONS):
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case TOGGLE_BANNER:
      return {
        ...state,
        showBanner: payload,
        syncIntegration: !payload ? null : state.syncIntegration,
      };
    case START_SYNC:
      return {
        ...state,
        showBanner: true,
        syncIntegration: payload,
      };
    case resolved(SAVE_INTEGRATION):
      return {
        ...state,
        data: state.data.map((i) => {
          if (i.hash === payload.hash) {
            return {
              ...i,
              ...payload,
            };
          }
          return i;
        }),
      };
    default:
      return state;
  }
};
